export default __webpack_public_path__ + "6c83abf62b98d37f755ae2da072381aa.png";